// fr.gestionpial.conf.services.FrontConfigBOServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';

@Injectable({
  providedIn: 'root',
})
export class FrontConfigBOService {
  private irpc = inject(IRPC);

  getConfigFile = (): RpcRequestBuilder<object> => {
    const req = new JSONRpcRequest();
    req.method = 'FrontConfigBOService.getConfigFile';
    req.params = [];
    return new RpcRequestBuilder(this.irpc, req, 'com.ic2.json.JSONObject');
  };

  saveConfigJson = (data: object): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'FrontConfigBOService.saveConfigJson';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(data, 'com.ic2.json.JSONObject', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

}
